import { request } from '../request'

export function search(query, scope) {
  return request(`/products.json?expression=${query}&${scope}`)
}

export function find(id) {
  return request(`/products/${id}.json`)
}
